import React, { useCallback, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import InputGroup from "../../../forms/InputGroup";
import "./prod_styles.css";
import { api_v2 } from "../../NewIndex.api";
import { getApplicationRegex } from "../../plugins/utils";
import { REF_DATA } from "../../../constants";
import connect from "react-redux/es/connect/connect";

const EditDetails = ({
  isModalOpen,
  setIsModalClose,
  validate,
  productObject,
  history,
  showNotification,
  referenceData
}) => {
  const editDetailsFields = {
    affiliate: {
      name: "Affiliate",
      value: productObject.affiliate,
      rules: { title: "Affiliate", required: true },
    },
    productName: {
      name: "Product Name",
      value: productObject.name,
      rules: { title: "Product Name", required: true },
    },
    productCode: {
      name: "Product Code",
      value: productObject.productCode,
      rules: { title: "Product Code", required: true },
    },
    veevaproductCode: {
      name: "Veeva product code",
      value: productObject.veevaProductCode,
      rules: { title: "Veeva Product Code", required: true },
    },
    prescriptionUrl: {
      name: "prescriptionUrl",
      value: productObject.piSearchLinks,
      rules: {
        title: "Prescription Information Search URL",
      },
      error: "Enter a correct URL!!",
    },
  };
  const [fields, setFields] = useState(editDetailsFields);
  const [isUrlCorrect, setIsUrlCorrect] = useState(false);

  const handleSaveClick = () => {
    const affiliate = fields.affiliate.value;
    const name = fields.productName.value;
    const productCode = fields.productCode.value;

    const url = `/admin/edit-products?affiliate=${encodeURIComponent(
      affiliate
    )}&name=${encodeURIComponent(name)}&productCode=${encodeURIComponent(
      productCode
    )}`;
    setTimeout(() => history.push(url), 2000);
  };

  const editDetails = () => {
    const payload = {
      id: productObject.id,
      name: fields.productName.value,
      veevaProductCode: fields.veevaproductCode.value,
      productCode: fields.productCode.value,
      piSearchLinks: fields.prescriptionUrl.value,
    };
    if (validateUrl()) {
      api_v2.updateExistingDetails(payload, (res) => {
        if (res.ok && res.status === 200) {
          showNotification(
            "Success",
            "Product updated successfully.",
            "success"
          );
          setIsModalClose();
          handleSaveClick();
        } else {
          showNotification(
            "Error",
            "There seems to be some error while updating product. Please try again later! ",
            "error"
          );
          setIsModalClose();
        }
      });
    }
    else {
      showNotification(
        "Error",
        fields.prescriptionUrl.error,
        "error"
      );
    }
  };

  const validateUrl = useCallback(() => {
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    const ref_Data = referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);

    const isUrlCorrect = fields.prescriptionUrl.value
      ? !regex.Emoji_Regex.test(fields.prescriptionUrl.value) &&
        !regex.Script_Regex.test(fields.prescriptionUrl.value) &&
        urlRegex.test(fields.prescriptionUrl.value)
      : true;

    return isUrlCorrect;
  }, [fields.prescriptionUrl.value]);

  return (
    <Modal
      className="edit-adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <div className="modal-title-color editDetails-modal-title">
        <h5>
          <strong>Edit Existing Product Details</strong>
        </h5>
        <h6>Please ensure that you enter the correct Veeva Product Code</h6>
      </div>
      <ModalBody>
        <div className="edit-adminConfirmationModal-modal-body-content">
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.affiliate}
              validate={(e, field) => validate(e, fields.affiliate)}
              disabled={true}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.productName}
              validate={(e, field) => validate(e, fields.productName)}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.productCode}
              maxLength={4}
              validate={(e, field) => validate(e, fields.productCode)}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.veevaproductCode}
              validate={(e, field) => validate(e, fields.veevaproductCode)}
            />
          </div>
          <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
            }}
          >
            <InputGroup
              searchable={false}
              clearable={false}
              field={fields.prescriptionUrl}
              validate={(e, field) => validate(e, fields.prescriptionUrl)}
            />
          </div>
          {/* <div
            className="row"
            style={{
              marginBottom: "10px",
              textAlign: "start",
              padding: "0 25px",
              color: "red",
            }}
          >
            {fields.prescriptionUrl.value &&
              !isUrlCorrect &&
              fields.prescriptionUrl.error}
          </div> */}
          <div className="edit-adminConfirmationModal-popup-button">
            <button
              type="button"
              onClick={() => {
                editDetails();
              }}
              className="btn btn-primary edit-adminConfirmationModal-button btn-rounded"
            >
              Save
            </button>
            <button
              type="button"
              onClick={setIsModalClose}
              className="btn btn-primary edit-adminConfirmationModal-button btn-rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps)(EditDetails);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/EditDetails.js